module.exports = __webpack_public_path__ + "img/btn_confirm3_jobmule.7fdde4f0.png";